import translate from '../../../i18n'
import {
  IOneTimeCodesFilterParams,
  OneTimeCodesFilterOrder,
} from '../../../pages/one-time-codes-container/share-type'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Form, Select, Input, DatePicker } from 'antd'
import dayjs from 'dayjs'
import { useEffect } from 'react'

const { Option } = Select
const { RangePicker } = DatePicker
const OneTimeCodesFilter = ({
  onSearch,
  formData,
  isNeedBatchId,
}: {
  onSearch: (value: IOneTimeCodesFilterParams) => void
  formData: IOneTimeCodesFilterParams | undefined
  isNeedBatchId?: boolean
}) => {
  const [form] = Form.useForm()
  useEffect(() => {
    if (formData) {
      form.setFieldsValue({
        ...formData,
        timeRange:
          formData.startDate && formData.endDate
            ? [dayjs(formData.startDate), dayjs(formData.endDate)]
            : undefined,
      })
    }
  }, [formData])
  const onFinish = (values: any) => {
    const { timeRange, ...other } = values
    onSearch({
      ...other,
      startDate: timeRange ? dayjs(timeRange[0]).utc().format() : undefined,
      endDate: timeRange ? dayjs(timeRange[1]).utc().format() : undefined,
    })
  }
  return (
    <Form form={form} layout="inline" style={{ gap: '8px' }} onFinish={onFinish}>
      {isNeedBatchId && (
        <Form.Item name="batchId" label="BatchId">
          <Input />
        </Form.Item>
      )}
      <Form.Item name="code" label="Code">
        <Input />
      </Form.Item>

      <Form.Item name="isRedeemed" label={translate('oneTimeCode.isRedeemed')}>
        <Select style={{ minWidth: 130 }} allowClear>
          <Option value={true}>是</Option>
          <Option value={false}>否</Option>
        </Select>
      </Form.Item>

      <Form.Item name="redeemedById" label={translate('oneTimeCode.redeemedBy')}>
        <Input />
      </Form.Item>

      <Form.Item name="timeRange" label={translate('oneTimeCode.timeRange')}>
        <RangePicker
          showTime={{
            defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')],
          }}
        />
      </Form.Item>

      <Form.Item name="orderBy" label={translate('oneTimeCode.orderBy')}>
        <Select style={{ minWidth: 130 }}>
          <Option value={OneTimeCodesFilterOrder.ID}>{translate('oneTimeCode.orderBy.id')}</Option>
          <Option value={OneTimeCodesFilterOrder.REDEEMED_AT}>
            {translate('oneTimeCode.orderBy.redeemedAt')}
          </Option>
        </Select>
      </Form.Item>

      <Form.Item>
        <Button htmlType="submit" type="primary" icon={<SearchOutlined />}>
          {translate('search')}
        </Button>
      </Form.Item>
    </Form>
  )
}

export default OneTimeCodesFilter
